import { FieldDefinition, FieldBuilder } from '@zendra/shared';

FieldBuilder.setNamespace('Geographic');

export const GISSTANDPERREGISTER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('standLocationName', 'Entity.GisStandPerRegister.StandLocation')
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('registerLocationName', 'Entity.GisStandPerRegister.RegisterLocation')
    .maxLength(100)
    .build(),
  FieldBuilder
    .number('standRegisterArea', 'Entity.GisStandPerRegister.StandRegisterArea')
    .required()
    .decimal()
    .build(),
  FieldBuilder
    .number('standLocationId', 'Entity.GisStandPerRegister.StandLocationId')
    .hideByDefault()
    .build(),
  FieldBuilder
    .number('registerLocationId', 'Entity.GisStandPerRegister.RegisterLocationId')
    .hideByDefault()
    .build(),
];

export const GISSTANDPERREGISTER_CONFIG = {
  entityName: 'GisStandPerRegister',
  localizationKey: 'Geographic::Entity.GisStandPerRegister',
  fields: GISSTANDPERREGISTER_FIELDS,
  permission: 'PlanningGeography.GisStandPerRegisters',
  showInMenu: false,
  menuCategory: '',
  menuSubcategory: '',
};
